import { CmsPublicationListMember } from '../../../../components/Cms';

export function CmsPublicationLayout() {
  return <CmsPublicationListMember />;
}
